<template>
  <div class="h-scroll h100-80">
    <div class="h-topo-tree">
      <ejs-treeview ref='PmNoRealTaskLeftTreeForResource' :nodeSelected="nodeSelectedOfResourceTreeForTask" :fields='fieldsOfResourceTreeForTask'></ejs-treeview>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PmNoRealTaskLeftTreeForResource',
  data() {
    return {
      fieldsOfResourceTreeForTask: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text',
      }
    };
  },
  methods: {
    // 网元树内容获取
    async getNeTree() {
      this.$axios.get('/lte/ems/pm/noReal/task/buildNoRealTaskTreeForResource.html').then((response) => {
        this.fieldsOfResourceTreeForTask = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    },

    // 网元树点击事件
    nodeSelectedOfResourceTreeForTask(args) {
      let neId = '';
      let neTypeCode = '';
      const attribute = this.$refs.PmNoRealTaskLeftTreeForResource.getTreeData(args.nodeData.id)[0].attributes;
      if(attribute){
        neId = attribute.neId ? attribute.neId : '';
        neTypeCode = attribute.neTypeCode ? attribute.neTypeCode : attribute.neTypeId ? attribute.neTypeId : '';
      }
      const params = {
        neId: neId,
        neTypeCode: neTypeCode
      }

      // 网元树点击节点信息事件发布
      this.$emit('resourceTreeClickEventPush', params);
    }
  },
  mounted() {
    this.getNeTree();
  }
};
</script>

<style>

</style>
